export default function ca(...args: any[]) {
  const ca = (window as any).ca;

  if (ca) {
    ca.apply(null, args);
  }
}



// WEBPACK FOOTER //
// ./src/di/cian_analytics.ts